import api from "./api.js";

export default class AccountApi {
  static async join(data, headers) {
    return await api.post(`api/auth/sign`, data, headers);
  }
  static async login(data, headers) {
    return await api.post(`api/auth/login`, data, headers);
  }

  static async myInfo() {
    return await api.get(`api/member/my-info`);
  }

  static async getNewToken() {
    return await api.post(`api/auth/reset/access`);
  }
}
